import { AfterViewInit, Directive, ElementRef, inject, OnInit, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { AuthService } from 'src/app/shared/services/auth.service';
import { filter } from 'rxjs';

@Directive({
    selector: 'app-accessibility',
})
export class ThemeDirective implements OnInit, AfterViewInit {
    private document = inject(DOCUMENT);
    private ecosistema: string;

    constructor(private authService: AuthService) {}
    ngOnInit(): void {
        this.authService.resetDataSubject.pipe(filter((x) => x.singIn)).subscribe(() => {
            const ecosistema = this.authService.ecosistema;
            this.document.body.classList.add(`theme-${ecosistema}`);
        });
        this.authService.resetDataSubject.pipe(filter((x) => x.singOut)).subscribe(() => {
            const ecosistema = this.authService.ecosistema;
            this.document.body.classList.remove(`theme-${ecosistema}`);
            this.authService.removeEcosistema();
        });
        this.authService.resetDataSubject.pipe(filter((x) => x.setTheme)).subscribe(({ ecosistema }) => {
            if (this.ecosistema) this.document.body.classList.remove(`theme-${this.ecosistema}`);
            this.ecosistema = ecosistema;
            if (ecosistema) this.document.body.classList.add(`theme-${ecosistema}`);
        });
    }
    ngAfterViewInit(): void {
        const ecosistema = this.authService.ecosistema;
        if (ecosistema) this.document.body.classList.toggle(`theme-${ecosistema}`);
    }
}
